"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipelineUtils = void 0;
const conveyor_belts_1 = require("./conveyor-belts");
const multi_belt_pipeline_1 = require("./multi-belt-pipeline");
exports.pipelineUtils = {
    ConveyorBelt: conveyor_belts_1.ConveyorBelt,
    MultiBeltPipeline: multi_belt_pipeline_1.MultiBeltPipeline,
};
